<template>
    <div class="side-hop">
        <img class="icon" src="../../img/icon-qrcode.svg">
        <div class="dingtalk">
            <img class="qrcode" src="../../img/qrcode-dingtalk.png">
            <div class="description">
                钉钉扫码<a target="_blank" href="https://qr.dingtalk.com/action/joingroup?code=v1,k1,/9x25BXdsOcxDDw8IqNsadAdRCEfg3mjVu9KYfWN7Eo=&_dt_no_comment=1&origin=11">加群</a><br/>
                收取每日调仓提醒
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SideHop"
    }
</script>

<style scoped lang="scss">
    .side-hop {
        position: fixed;
        right: 10px;
        bottom: 60px;
        width: 40px;
        height: auto;
        min-height: 40px;
        padding: 5px;
        border-radius: 3px;
        border: 1px solid var(--color-border);
        background-color: var(--color-background);
        transition: width .2s, height .2s, opacity .1s;
        text-align: center;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
        opacity: .75;

        .icon {
            width: 100%;
            height: 100%;
        }

        .dingtalk {
            display: none;

            .qrcode {
                width: 100%;
            }

            .description {
                line-height: 1.5;
                color: var(--color-minor-text);
                font-size: .75em;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;

                a {
                    text-decoration: underline;
                }
            }
        }
        &:hover {
            width: 200px;
            padding: 10px;
            opacity: 1;

            .icon {
                display: none;
            }

            .dingtalk {
                display: block;
            }
        }

    }
</style>